
import React from 'react';
import { Link } from 'react-router-dom';

const projects = [
  { 
    id: 1, 
    name: 'Wemax App Suite', 
    description: 'Suite de herramientas para gestión de proyectos',
    progress: 75,
    updated: 'Hace 2 horas',
    color: 'bg-[#ff1b6d]'
  },
  { 
    id: 2, 
    name: 'Dashboard UI', 
    description: 'Diseño de interfaz para el dashboard principal',
    progress: 90,
    updated: 'Ayer',
    color: 'bg-blue-600'
  },
  { 
    id: 3, 
    name: 'API Integration', 
    description: 'Integración con servicios externos',
    progress: 45,
    updated: 'Hace 3 días',
    color: 'bg-green-600'
  },
];

function RecentProjects() {
  return (
    <div className="space-y-4">
      {projects.map((project) => (
        <Link
          key={project.id}
          to={`/projects/${project.id}`}
          className="block p-4 bg-[#252525] rounded-lg hover:bg-[#2a2a2a] transition-colors duration-200"
        >
          <div className="flex justify-between">
            <div>
              <h4 className="text-base font-medium text-white">
                {project.name}
              </h4>
              <p className="text-sm text-gray-400 mt-1">
                {project.description}
              </p>
            </div>
            <div className={`h-10 w-10 rounded-full flex items-center justify-center ${project.color}`}>
              <span className="text-white text-xs font-medium">
                {project.progress}%
              </span>
            </div>
          </div>
          <div className="mt-4">
            <div className="w-full bg-[#1a1a1a] rounded-full h-2">
              <div
                className={`${project.color} h-2 rounded-full`}
                style={{ width: `${project.progress}%` }}
              ></div>
            </div>
          </div>
          <div className="mt-2 text-xs text-gray-400">
            Actualizado {project.updated}
          </div>
        </Link>
      ))}
      <Link 
        to="/projects" 
        className="block text-center text-sm text-[#ff1b6d] hover:text-[#ff1b6d]/80 py-2"
      >
        Ver todos los proyectos
      </Link>
    </div>
  );
}

export default RecentProjects;

